import React, { Component, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import history from '../../../route/history'
import { regisActions, alertActions } from '../../../store/actions'
import KTnetModal2 from '../../../module/ktnet/KTnetModal2'
import KTnetModalExport from '../../../module/ktnet/KTnetModalExport'
import KTnetModalImport from '../../../module/ktnet/KTnetModalImport'
import Input from '../../../module/input'
import moment from 'moment'
import Alert from '../../../module/alert/Alert'
import { valid } from '../../../hook/valid'
import CrtfctStep01 from './CrtfctStep01.js'
import CrtfctStep02 from './CrtfctStep02.js'
import CrtfctStep03 from './CrtfctStep03.js'

const CrtfctManagement = (props) => {
  // 공인인증 툴킷open 여부
  const [isKTnetOpen, setIsKTnetOpen] = useState(false)

  const [isKTnetOpenExport, setIsKTnetOpenExport] = useState(false)

  const [isKTnetOpenImport, setIsKTnetOpenImport] = useState(false)

  const [state, setState] = useState({
    isView: false,
    regNo1: '',
    regNo2: '',
    checkedRegNo: false, //주민번호 정상체크
    regNo: '',
  })

  const [certChkInfo, setCertChkInfo] = useState({
    signCompleted: false,
    certChkYn: 'Y',
  })

  //사용자 가입용 데이터
  const [userInfo, setUserInfo] = useState({
    jtCrtfctId: '',
    jtCrtfctDn: '',
    bgngYmd: '',
    endYmd: '',
  })

  const handleChange = (e) => {
    const { value, name } = e.target // 우선 e.target 에서 name 과 value 를 추출
    setState({
      ...state, // 기존의 input 객체를 복사한 뒤
      [name]: value, // name 키를 가진 값을 value 로 설정
    })
  }
  /**
   * 인증서 툴킷 띄우기 전에 번호 확인
   * @param regNo1
   * @param regNo2
   * @returns
   */
  const toolkitCheckRegNo = (regNo1, regNo2) => {
    /*   setState({
        ...state,
        regNo: state.regNo1 + state.regNo2 
      }) */
    if (!regNo1) {
      return props.error({ message: '주민번호 앞자리를 입력해주세요.' })
    }
    if (!regNo2) {
      return props.error({ message: '주민번호 뒷자리를 입력해주세요.' })
    }

    let checkResult = valid.isValidJuminNo(regNo1, regNo2)
    if (!checkResult) {
      return props.error({ message: '정상적인 주민등록 번호가 아닙니다.' })
    }

    props.checkedRegNo(checkResult)
  }
  const checkStepTrue = () => {
    localStorage.setItem('isSave', true)
  }
  const checkStepFalse = () => {
    localStorage.setItem('isSave', false)
  }
  /**
   * 인증서 콜백
   * @param info
   */
  const crtfctInfo = (info) => {
    //console.log(localStorage.getItem('isSave'));
    if (localStorage.getItem('isSave') === 'true') {
      props.onCrtfctfInfo(info)
      localStorage.removeItem('isSave')
    } else {
      props.delCrtfctfInfo(info)
      localStorage.removeItem('isSave')
    }
  }

  //tab
  let [step, setStep] = useState(1)

  const onSelected = (value) => {
    setStep(value)
  }

  const prePage = (e) => {
    e.preventDefault()
    history.goBack()
  }

  useEffect(() => {
    const search = props.location.search
    const params = new URLSearchParams(search)
    const step = params.get('step')
    if (step) {
      setStep(Number(step))
    }
  }, [])

  return (
    <React.Fragment>
      {/* container */}
      <div id="container">
        {/* contents */}
        <div id="contents">
          <div className="content-header">
            <a href="#" className="page-prev" onClick={prePage}>
              뒤로이동
            </a>
            {/* <!-- mobile --> */}
            {/* <h2>{step === 3 ? '사설인증서 관리' : '공동인증서 관리'}</h2> */}
            <h2>공동인증서 관리</h2>
            <div className="breadcrumb">
              <span>Home</span>
              <span>마이페이지</span>
              <em>인증서 관리</em>
            </div>
          </div>
          {/* <div className="pc-only"> */}
          <ul className="nav-tab w200">
            <li
              className={step === 1 ? 'on' : ''}
              onClick={() => {
                onSelected(1)
              }}
            >
              <a href="#" onClick={(e) => e.preventDefault}>
                공동인증서 등록/삭제
              </a>
            </li>
            <li
              className={step === 2 ? 'on' : ''}
              onClick={() => {
                onSelected(2)
              }}
            >
              <a href="#" onClick={(e) => e.preventDefault}>
                공동인증서 복사
              </a>
            </li>
            {/* <li
              className={step === 3 ? 'on' : ''}
              onClick={() => {
                onSelected(3)
              }}
            >
              <a href="#" onClick={(e) => e.preventDefault}>
                사설인증서 관리
              </a>
            </li> */}
          </ul>
          {step === 1 && <CrtfctStep01 />}
          {step === 2 && <CrtfctStep02 />}
          {step === 3 && <CrtfctStep03 />}
        </div>
        {/* </div> */}
        {/* //contents */}
      </div>
      {/* //container */}
      {/* <Alert /> */}
    </React.Fragment>
  )
}

const mapStateToProps = (state) => {
  return {
    checkedRegNo: state.regis.checkedRegNo,
  }
}

const actionCreators = {
  success: alertActions.success,
  error: alertActions.error,
  checkedRegNo: regisActions.checkedRegNo,
  onCrtfctfInfo: regisActions.onCrtfctfInfo,
  delCrtfctfInfo: regisActions.delCrtfctfInfo,
}

export default connect(mapStateToProps, actionCreators)(CrtfctManagement)
